<template>
  <div class="quote-block">
    <p class="quote-block__text">Price breakdown in a Quote</p>
    <CheckboxField v-model="estimateStore.estimate.priceBreakdownInQuote" />
  </div>
</template>

<script setup lang="ts">
import { CheckboxField } from "@/shared";
import { useNewEstimateStore } from "@/stores/new/estimateStore";

const estimateStore = useNewEstimateStore();
</script>

<style scoped>
.quote-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-block: 24px;
  border-top: 1px solid #d2d8e3;
}

.quote-block__text {
  font-weight: 400;
  font-style: Regular;
  font-size: 13px;
  line-height: 100%;
  color: #052141;
}
</style>
